import { render, staticRenderFns } from "./club-points-detail.vue?vue&type=template&id=1ff1fc45&"
import script from "./club-points-detail.vue?vue&type=script&lang=js&"
export * from "./club-points-detail.vue?vue&type=script&lang=js&"
import style0 from "./club-points-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff1fc45')) {
      api.createRecord('1ff1fc45', component.options)
    } else {
      api.reload('1ff1fc45', component.options)
    }
    module.hot.accept("./club-points-detail.vue?vue&type=template&id=1ff1fc45&", function () {
      api.rerender('1ff1fc45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/club-points-detail.vue"
export default component.exports